import axiosOriginal from 'axios'
import apiRoutes from 'routes/admin_api_routes.json'

import liteApiRoutes from '../../../routes/lite_api_routes.json'
import { handleApiError } from '../../util/parse_server_error'
import { setFetched } from '../api/actions'
import { setCurrent } from '../current/actions'

export function addAccount(email) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_signup_index.path
    return axios()
      .post(path, { email })
      .then(
        (result) => {
          return Promise.resolve(result)
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function removeAccount(id) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_account.path
    const url = path.replace(':id', id)
    return axios()
      .delete(url)
      .then(
        () => {
          window.location.reload()
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}

export function createLiveChatAccount(axios, dispatchRootStore, dispatch) {
  const { account, id, collection, name, email } = window.speakeasySettings
  return axiosOriginal
    .post(
      liteApiRoutes.lite_api_v1_sessions.path,
      { account, id, collection, name, email },
      {
        ...axios.defaults,
        baseURL:
          window.speakeasySettings.apiBase +
          liteApiRoutes.lite_api_v1_root.path,
      },
    )
    .then((result) => {
      const jwt = result.data.jwt
      localStorage.setItem(
        window.speakeasyData.jwtLsId,
        jwt,
      )
      axios.defaults.headers.common['AUTHORIZATION'] = `Bearer ${jwt}`
      axios.defaults.baseURL =
        window.speakeasySettings.apiBase +
        liteApiRoutes.lite_api_v1_member_root.path.replace(
          ':current_member_id',
          Object.keys(result.data.records.members.data)[0],
        )
      dispatchRootStore(setFetched('accounts', result.data.records))
      dispatchRootStore(setCurrent(result.data.root_store_current))
      dispatch(setFetched('accounts', result.data.records))
      dispatch(setCurrent(result.data.sub_store_current))
      const updatedAxiosConfig = {
        headers: {
          ['AUTHORIZATION']: `Bearer ${jwt}`,
        },
        baseURL:
          window.speakeasySettings.apiBase +
          liteApiRoutes.lite_api_v1_member_root.path.replace(
            ':current_member_id',
            Object.keys(result.data.records.members.data)[0],
          ),
      }
      return Promise.resolve(updatedAxiosConfig)
    })
}

export const fetchLiveChatAccount = (axios) => {
  return axios.get(
    liteApiRoutes.lite_api_v1_accounts.path +
      `?account=${window.speakeasySettings.account}&video=${window.preloadData.rootStore.liveChatAppId}`,
    {
      baseURL:
        window.speakeasySettings.apiBase +
        liteApiRoutes.lite_api_v1_root.path,
    },
  )
}

export const updateLiveChatAccount = (data) => {
  return function (axios, dispatch) {
    const path = liteApiRoutes.lite_api_v1_account.path
    return axios()
      .put(path, data)
      .then(
        (result) => {
          dispatch(setFetched('accounts', result.data.records))
        },
        (result) => {
          handleApiError({
            dispatch,
            result,
            path,
          })
          return Promise.reject(result)
        },
      )
  }
}
